/* eslint-disable @next/next/no-img-element */
import { Box } from "src/components/UI";

type BulletNumberedImageCardProps = {
  imageSrc: string;
  imageAlt: string;
};

const BulletNumberedImageCard = (props: BulletNumberedImageCardProps) => {
  const { imageSrc, imageAlt, ...restProps } = props;
  return (
    <Box
      justifyContent={["unset", "space-between"]}
      gap={["unset", "16px"]}
      {...restProps}
    >
      <Box
        padding={["0 26px", "0"]}
        width={["100%", "100%"]}
        height={["unset", "auto"]}
      >
        <img
          src={imageSrc}
          alt=""
          style={{ width: "100%", height: "inherit", objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
};

export default BulletNumberedImageCard;
